import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Address } from 'src/app/models/address';
import { ApiProviderService } from 'src/app/services/api-provider.service';

import { debounceTime, distinctUntilChanged, filter, map, switchMap } from "rxjs/operators";
import { fromEvent, Observable, of, pipe } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { FromAddressComponent } from '../form-address/from-address.component';

@Component({
  selector: 'app-list-address-selectable',
  templateUrl: './list-address-selectable.component.html',
  styleUrls: ['./list-address-selectable.component.scss'],
})
export class ListAddressSelectableComponent implements OnInit {


  @Input() isOneValueSelectable: boolean = false;
  //Permet de recuperer une liste d'addresse qui vient de l'exterieur du module
  @Input() selectedAddresses : Address[] = [];
  @Output() address = new EventEmitter<Address[]>();
  
  addresses$: Observable<Address[]> ;
  save$: Observable<Address[]> ;

  search : string;

  constructor(
    private apiProvider: ApiProviderService,
    private userService : UserService,
    public modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.addresses$ = this.save$ = this.apiProvider.getAddressesByCoach(this.userService.getUser());
  }

  selectedAddress(address: Address){
    if(this.isOneValueSelectable)
    {
      this.selectedAddresses = [address];
    }else{
      this.selectedAddresses.push(address);
    }
  }

  deleteAddress(index: number){
    this.selectedAddresses.splice(index,1);
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
      this.address.emit(this.selectedAddresses);
      return this.modalCtrl.dismiss(this.selectedAddresses, 'confirm');
  }

  addressSearch(event){
    if(event){
      this.addresses$ = this.save$.pipe(
        map(addresses => addresses.filter(
          address => address.name.toLowerCase().includes(event.toLowerCase()) || address.addresse.toLowerCase().includes(event.toLowerCase()) || address.city.toLowerCase().includes(event.toLowerCase()) 
          ))
       );
    }else{
      this.addresses$ = this.save$;
    }
  }

  async addAdress(){
    const addressModal = await this.modalCtrl.create({
      component: FromAddressComponent
    });

    addressModal.present();

    const { data, role } = await addressModal.onWillDismiss();

    if(role == "create"){
      this.addresses$ = this.addresses$.pipe(
        map(
          address => {
            return address;
          }
        )
      );
      
      this.selectedAddresses.push(data);
    }


  }
}
